import {CPSConstants} from "commonUtils/enumerations";

export const mFADialogStyle = {
  DialogPadding: {
    padding: "10px 24px",
  },
  CloseIcon: {
    position: "absolute",
    right: "0.5rem",
    top: "0.5rem",
    color: "#1D2C6E",
  },
  Icon: {
    width: "1.2rem",
    paddingTop: "0.313rem",
  },
  TypoGraphyTitle: {
    fontSize: CPSConstants.FONTREMTEXT,
    opacity: 1,
    color: "#000000",
    marginBottom: "0.25rem",
    fontWeight: "medium",
  },
  TypoGraphyAddress: {
    fontSize: CPSConstants.FONTREMTEXT,
    opacity: 1,
    color: "#1F0B0B",
    marginBottom: "1.25rem",
    fontWeight: "medium",
  },
  TypoGraphyMsgCenter: {
    fontSize: CPSConstants.FONTREMHEAD,
    opacity: 1,
    p: "0px 0px 20px 0px",
    color: "#1F0B0B",
    marginBottom: "1.25rem",
    fontWeight: 700,
  },
  Link: {
    fontSize: CPSConstants.FONTREMTEXT,
    opacity: 1,
    color: "#1D2A69",
  },
  GridItem: {
    display: "flex",
    alignItems: "start",
    justifyContent: "flex-start",
  },
  selectControl: {
    mb: 1,
    minWidth: 80,
  },
  GridItemCenter: {
    mt: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  extratext: {
    color: "#1F0B0B",
    fontSize: CPSConstants.FONTREMTEXT,
    fontWeight: CPSConstants.FONTWEIGHT,
  },
  selectHeightRadius: {
    height: "3rem",
    borderRadius: "4px 0px 0px 4px",
  },
  inputRadius: {
    "& .MuiInputBase-root": {
      height: "3rem",
      borderRadius: "0px 4px 4px  0px",
      maxWidth: "100%",
      width: "100vw",
    },
  },
  otpContainer: {
    display: "flex",
    flexDirection: "column",
    alignContent: "space-around",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
  },
  marginBottom: {
    mb: "10px"
  },
};
